module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total products")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.productsTotal)))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total applications")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientsTotal)))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total users")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.usersTotal)))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Callslots Useage")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ""
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(this.$store.state.uesdslot) + "/" + _vm._s(this.$store.state.allslot))])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f53aaa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 200
// module chunks = 1